
import { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import WhatWeDo from './components/WhatWeDo';
import CoreServices from './components/CoreServices';
import StaffTraining from './components/StaffTraining';
import Credentials from './components/Credentials';
import WhoWeServe from './components/WhoWeServe';
import HowWeOperate from './components/HowWeOperate';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-black">
      <Navigation scrolled={scrolled} />
      <Hero />
      <Philosophy />
      <WhatWeDo />
      <CoreServices />
      <StaffTraining />
      <Credentials />
      <WhoWeServe />
      <HowWeOperate />
      <Contact />
      <Footer />
    </div>
  );
}
